import { type PropsWithChildren } from 'react'
import { useUser } from '../../providers/Auth/hooks'

interface ProtectedProps {
  role: string
  fallbackRoles?: string[]
}

const Protected: React.FC<PropsWithChildren & ProtectedProps> = ({
  children,
  role,
  fallbackRoles = []
}) => {
  const user = useUser()

  if (!user) return null

  const hasAccess = user.user.roles.includes(role) ||
                   fallbackRoles.some(fallbackRole => user.user.roles.includes(fallbackRole))

  if (!hasAccess) return null

  return <>{children}</>
}

export default Protected
